import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMe, MAIN_API_URL, SITE } from "../utils/auth";
import '../../css/LoginPage.css';
import SEO from '../utils/SEO';

async function readLoginResponse(response) {
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        return await response.json();
    }
    const body = await response.text();
    console.error("Authentication endpoint returned a non-JSON response", {
        status: response.status,
        contentType,
        bodyStart: body.slice(0, 160),
    });
    throw new Error("Unable to reach the authentication service. Please try again.");
}

export default function LoginPage({ onAuthenticated }) {
    const navigate = useNavigate();
    console.log(MAIN_API_URL);

    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError("");

        try {
            const loginIdentifier = formData.username.trim();
            const isEmailLogin = loginIdentifier.indexOf("@") !== -1;
            const loginPayload = {
                password: formData.password,
                site: SITE,
            };

            if (isEmailLogin) {
                loginPayload.email = loginIdentifier.toLowerCase();
            } else {
                loginPayload.username = loginIdentifier;
            }

            const response = await fetch(`${MAIN_API_URL}/token/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Site": SITE,
                },
                body: JSON.stringify(loginPayload),
            });

            const data = await readLoginResponse(response);

            if (!response.ok) {
                throw new Error(
                    data.detail || "Unable to log in."
                );
            }

            localStorage.setItem("access", data.access);
            localStorage.setItem("refresh", data.refresh);
            localStorage.setItem("username", data.username || formData.username);
            localStorage.setItem("site", data.site || SITE);
            localStorage.setItem("acting_site", data.acting_site || SITE);
            localStorage.setItem("is_staff", String(Boolean(data.is_staff)));
            localStorage.setItem("is_superuser", String(Boolean(data.is_superuser)));
            localStorage.setItem("is_partner", String(Boolean(data.is_partner || data.is_superuser)));
            localStorage.setItem("email_verified", String(Boolean(data.email_verified)));
            localStorage.setItem("portal_role", data.portal_role || (data.is_superuser ? "superuser" : "client"));
            localStorage.setItem("portal_roles", JSON.stringify(data.portal_roles || data.additional_roles || []));
            localStorage.setItem("permissions", JSON.stringify(data.permissions || []));
            localStorage.setItem("is_client", String(Boolean(data.is_client)));
            localStorage.setItem("is_internal", String(Boolean(data.is_internal || data.is_superuser)));

            let roleData = data;
            try {
                roleData = await fetchMe();
                localStorage.setItem("is_partner", String(Boolean(roleData.is_partner || roleData.is_superuser)));
                localStorage.setItem("is_superuser", String(Boolean(roleData.is_superuser)));
                if (roleData.user_id) localStorage.setItem("user_id", roleData.user_id);
                localStorage.setItem("portal_role", roleData.portal_role || (roleData.is_superuser ? "superuser" : "client"));
                localStorage.setItem("portal_roles", JSON.stringify(roleData.portal_roles || roleData.additional_roles || []));
                localStorage.setItem("permissions", JSON.stringify(roleData.permissions || []));
                localStorage.setItem("is_client", String(Boolean(roleData.is_client)));
                localStorage.setItem("is_internal", String(Boolean(roleData.is_internal || roleData.is_superuser)));
            } catch (roleErr) {
                console.warn("Unable to refresh user role after login", roleErr);
            }

            if (onAuthenticated) {
                onAuthenticated(roleData);
            }

            navigate("/dashboard");
        } catch (err) {
            setError(err.message || "Unable to reach the authentication service. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <SEO
            title="SCD Portal Login | South Central Development"
            description="Secure login for South Central Development clients, partners, and staff."
            path="/"
            noindex
        />
        <div className="login-page">
            <div className="login-card">
                <div className="login-brand-mark">SCD</div>
                <h1>South Central Development</h1>

                <p className="login-subtitle">
                    Sign in to access your client or partner dashboard
                </p>

                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                        <form onSubmit={handleSubmit}>
                            <div>
                                <label>Email / Username</label>

                                <input
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div>
                                <label>Password</label>

                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Logging in..." : "Log In"}
                            </button>
                        </form>
                <div className="login-footer">
                    Secure SCD Portal Access
                </div>
            </div>
        </div>
        </>
    );
}
